import * as React from "react";
import * as ReactDOM from "react-dom";
import { HomepageDisability } from "./index";
import Config from '@lib/Config';
import Analytics from '@lib/Analytics';

const mode = 'homepage_disability';

Config.init({
  mode,
  industryType: 'Medsup',
  useStaticPhones: true,
});
Analytics.init(mode);

ReactDOM.hydrate(
  <HomepageDisability pathname={location.pathname} mode={mode} />,
  document.getElementById("root")
);
